import { cn } from "@gettactic/helpers";
import { Info } from "lucide-react";
import type React from "react";

export const infoBoxIcon = (
  <Info className="mt-0.5 h-4 w-4 shrink-0 text-neutral-400" />
);

export interface PopoverInfoBoxProps {
  icon?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

/** Shared info box used for the description, approval helper and restriction. */
export const PopoverInfoBox: React.FC<PopoverInfoBoxProps> = ({
  icon,
  className,
  children
}) => (
  <div
    className={cn(
      "mt-3 flex items-start gap-2.5 rounded-[10px] border-[0.5px] border-neutral-400/50 border-solid bg-[#fbfcfd] px-[13px] py-[11px]",
      className
    )}
  >
    {icon}
    <div className="min-w-0 font-inter text-[#3a444b] text-[13px] leading-[20.15px]">
      {children}
    </div>
  </div>
);
